
<template>
  <div>
    <v-container class="text-center mt-10">
      <h1 class="green--text text--darken-3">Verifikasi dan Aktivasi Akun</h1>
      <!--      <p class="mt-10">Permintahan Login Sudah dikirim kepada Admin.</p>-->
      <!--      <p>Silahkan tunggu untuk mendapatkan Whatsapp Notifikasi</p>-->
      <div class="font-italic d-flex align-baseline mt-4">
        Akun Anda Telah AKTIF, silahkan
        <v-btn
          @click="login"
          color="primary"
          outlined
          class="ml-2 rounded-lg"
          lowercase
          >Login Disini</v-btn
        >
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "VerifikasiLoginLinkSendView",
  components: {},
  data() {
    return {};
  },
  methods: {
    login() {
      this.$router.push("/login");
    },
    submit() {
      this.$router.push("/home");
    },
  },
};
</script>

<style scoped>
.blue-underline {
  text-decoration: underline;
  text-transform: lowercase;
  text-decoration-color: #0d467f;
  color: #115190 !important;
}
</style>